<div class="px-gutter py-gutter" @stagger>
  <div @fadeInUp class="mb-6 flex flex-wrap items-start justify-between gap-4">
    <div>
      <h1 class="headline m-0">Équipes</h1>
      <p class="m-0 mt-1 caption text-secondary">Maquette : données fictives</p>
    </div>
    <div class="flex flex-wrap items-center gap-4">
      <team-action-mock-new-toggle></team-action-mock-new-toggle>
      <button mat-raised-button color="primary" type="button" (click)="create()">
        <mat-icon class="mr-1">add</mat-icon>
        AJOUTER
      </button>
    </div>
  </div>
  <div @fadeInUp class="card overflow-hidden">
    <team-action-mock-team-table [teams]="(teams$ | async) ?? []" [linkable]="true"></team-action-mock-team-table>
  </div>
</div>
